module.exports = __webpack_public_path__ + "img/CompanyoperationproofaddressZh.e2ae850e.jpg";